import type { LeaderboardResponse } from "@monekineko/shared";
import { Avatar, Button, EmptyState, Segmented, Skeleton, StarRating } from "@monekineko/ui-kit";
import { useEffect, useState } from "react";
import clsx from "clsx";
import { api } from "../api.js";
import styles from "./screens.module.css";

// Рейтинг: за неделю и за всё время. Своя строка показывается всегда,
// даже если игрок не попал в сотню.

export function LeaderboardScreen({ onBack }: { onBack: () => void }) {
  const [period, setPeriod] = useState<"week" | "all">("week");
  const [data, setData] = useState<LeaderboardResponse | null>(null);

  useEffect(() => {
    setData(null);
    void api.leaderboard(period).then(setData).catch(() => undefined);
  }, [period]);

  return (
    <div className={styles.screen}>
      <div className={styles.topBar}>
        <Button variant="ghost" size="sm" onClick={onBack}>
          ← Назад
        </Button>
        <span className={styles.levelTitle}>Рейтинг</span>
        <span />
      </div>

      <Segmented
        value={period}
        onChange={setPeriod}
        options={[
          { value: "week", label: "Неделя" },
          { value: "all", label: "Всё время" },
        ]}
      />

      {!data ? (
        <>
          <Skeleton height={44} />
          <Skeleton height={44} />
          <Skeleton height={44} />
        </>
      ) : data.rows.length === 0 ? (
        <EmptyState title="Рейтинг пуст" description="Пройди уровень — и окажешься первым" />
      ) : (
        <ol className={styles.board}>
          {data.rows.map((row) => (
            <li key={`${row.rank}-${row.name}`} className={clsx(styles.boardRow, row.isMe && styles.boardMe)}>
              <span className={styles.rank}>{row.rank}</span>
              <Avatar src={row.photoUrl} name={row.name} size={28} />
              <span className={styles.boardName}>{row.name}</span>
              <StarRating value={Math.min(3, row.stars)} />
              <span className={styles.boardPoints}>{row.points}</span>
            </li>
          ))}
        </ol>
      )}

      {data?.me && !data.rows.some((row) => row.isMe) ? (
        <div className={clsx(styles.boardRow, styles.boardMe, styles.boardSticky)}>
          <span className={styles.rank}>{data.me.rank}</span>
          <Avatar src={data.me.photoUrl} name={data.me.name} size={28} />
          <span className={styles.boardName}>{data.me.name}</span>
          <span className={styles.boardPoints}>{data.me.points}</span>
        </div>
      ) : null}
    </div>
  );
}
